import React from 'react';
import removeOtherTraffic from 'src/components/BeaconV2Components/utils/removeOtherTraffic';
import { useAppSelector } from 'src/utils/Hooks';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';
import useAtlasV2KeywordSearchRequestBuilder from 'src/components/AtlasV2Components/AtlasV2Sidebar/AtlasV2SearchSidebar/useAtlasV2KeywordSearchRequestBuilder';
import AtlasV2DropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DropdownMetricColumnChart';

/**
 * Atlas V2 Bar chart for topics builder search results
 */
export default function AtlasV2TopicBuilderColumnChart({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) {
  const keywordSearchRequestBuilder = useAtlasV2KeywordSearchRequestBuilder();
  const builderToUse = builderFunction || keywordSearchRequestBuilder;

  const mainEntityType = useAppSelector((state) => state?.entityService?.mainEntity?.type);

  return (
    <AtlasV2DropdownMetricColumnChart
      fieldName="organicClicks"
      indexName="traffic"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(mainEntityType))}
      useAdvancedSearchDataArgs={{
        requestBuilder: (builder) => builder.apply(removeOtherTraffic).apply(builderToUse())
      }}
      titlePrefix="Organic Traffic by"
    />
  );
}
